import React from 'react';
import { Description } from '@material-ui/icons';
import {
    DATA,
    ADJUSTMENT_DATA,
    SUBDEALS,
    TEAM_MANAGER_DRAW,
    WeOwes,
    HOLDBACK_DATA,
    UPDATE_ACCOUNTING_DEALS,
} from '../../../../../../consts/urls';

export const messageButtons = {
    title: 'DMS Extraction',
    icon: <Description />,
    children: [
        {
            title: 'Deals By Month',
            icon: <Description />,
            action: 'term',
            endPoint: DATA,
            text: 'Please Select Month And Year Yo Extract Deals',
        },
        {
            title: 'Weowes By Month',
            icon: <Description />,
            action: 'term',
            endPoint: WeOwes,
            text: 'Please Select Month And Year To Extract Deals',
        },
        {
            title: 'Holdback By Month',
            icon: <Description />,
            action: 'term',
            endPoint: HOLDBACK_DATA,
            text: 'Please Select Month And Year To Extract Hold Backs',
        },
        {
            title: 'Update Accounting Deals By Month',
            icon: <Description />,
            action: 'term',
            endPoint: UPDATE_ACCOUNTING_DEALS,
            text: 'Please Select Month And Year To Update Accounting Deals',
        },
        {
            title: 'Deals By Number',
            icon: <Description />,
            action: 'deal',
            endPoint: DATA,
            text: 'Enter Deal Number To Extract It',
        },
        {
            title: 'Adjustments By Month',
            icon: <Description />,
            action: 'term',
            endPoint: ADJUSTMENT_DATA,
            text: 'Please select Month and Year to extract Adjustments',
        },
        {
            title: 'Create Sub Deals By Month',
            icon: <Description />,
            action: 'term',
            endPoint: SUBDEALS,
            text: 'Please select Month and Year to create Sub Deals',
        },
        {
            title: 'Create TM Draws By Month',
            icon: <Description />,
            action: 'termTMDraws',
            endPoint: TEAM_MANAGER_DRAW,
            text: 'Please select Month and Year to create TM Draws',
        },
        /* {
        title: 'Adjustments by deal',
        icon: <Description />
      },
      {
        title: 'Adjustment by deal',
        icon: <Description />
      },*/
    ],
};
